import { useTheme } from "@hooks/useTheme";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CalendarIcon } from "@components/Icons";
import { useTranslation } from "react-i18next";
import { registerLocale } from "react-datepicker";
import { enUS, ko, ja } from "date-fns/locale";

registerLocale("en", enUS);
registerLocale("ko", ko);
registerLocale("ja", ja);


const CustomDatePicker = ({
  selected,
  onChange,
  placeholderText,
  dateFormat = "yyyy-MM-dd",
  isClearable = true,
  minDate,
  maxDate,
  selectsRange = false,
  startDate,
  endDate,
  wrapperClassName,
  className,
  popperClassName = "datepicker-dark-theme",
  showIcon = true,
  iconPosition = "right",
  size = "md",
  ...props
}) => {
  const { colors } = useTheme();
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const locale = currentLang || "en";
  const sizeConfigs = {
    sm: {
      height: "h-9",
      padding: "px-2.5 py-1.5",
      iconTop: "top-2",
      iconRight: "right-2",
    },
    md: {
      height: "h-10",
      padding: "p-3",
      iconTop: "top-3",
      iconRight: "right-4",
    },
    lg: {
      height: "h-12",
      padding: "p-4",
      iconTop: "top-4",
      iconRight: "right-4",
    },
  };

  const currentSize = sizeConfigs[size] || sizeConfigs.md;

  const isEmpty = selectsRange ? !startDate : !selected;
  const shouldShowClearButton = isClearable && !isEmpty;
  const defaultClassName = `${currentSize.height} w-full rounded-md border ${currentSize.padding} text-sm focus:outline-none ${colors.focusBorder} ${colors.borderPrimary} ${colors.bgInput} ${colors.textPrimary} ${colors.textPlaceholder || ""} ${colors.borderHoverPrimary || ""}`;

  const mergedClassName = className || defaultClassName;
  const mergedWrapperClassName = wrapperClassName || "w-full";
  const iconColor = colors.getSelectColor ? colors.getSelectColor(isEmpty) : (isEmpty ? colors.emptyColorDatePicker : colors.colorDatePicker);

  const iconClasses = iconPosition === "right" 
    ? `absolute ${currentSize.iconTop} ${currentSize.iconRight} h-4 w-4`
    : `absolute ${currentSize.iconTop} left-4 h-4 w-4`;

  return (
    <div className="relative">
      <DatePicker
        selected={selected}
        onChange={onChange}
        placeholderText={placeholderText}
        dateFormat={dateFormat}
        isClearable={shouldShowClearButton}
        minDate={minDate}
        maxDate={maxDate}
        selectsRange={selectsRange}
        startDate={startDate}
        endDate={endDate}
        wrapperClassName={mergedWrapperClassName}
        className={mergedClassName}
        popperClassName={popperClassName}
        locale={locale}
        {...props}
      />
      {showIcon && (
        <>
          {isEmpty && (
            <CalendarIcon
              className={`pointer-events-none ${iconClasses}`}
              style={{ color: iconColor }}
            />
          )}
        </>
      )}
    </div>
  );
};

export default CustomDatePicker;
